(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gogro-market"] && !Shopify.designMode) return;
  try {
    
(function(){const root=document.querySelector('#gogro-market');if(!root)return;const rows=[...root.querySelectorAll('[data-market-row]')],canvas=root.querySelector('#gm-canvas'),dialog=root.querySelector('#gm-dialog');let selected=rows[0];
function draw(){if(!selected)return;const box=canvas.getBoundingClientRect(),d=window.devicePixelRatio||1;canvas.width=box.width*d;canvas.height=box.height*d;const c=canvas.getContext('2d');c.scale(d,d);const w=box.width,h=box.height,a=selected.dataset.history.split(',').map(Number),lo=Math.min(...a),hi=Math.max(...a),r=hi-lo||1;c.clearRect(0,0,w,h);c.strokeStyle='rgba(140,170,145,.15)';for(let i=1;i<5;i++){c.beginPath();c.moveTo(0,h*i/5);c.lineTo(w,h*i/5);c.stroke()}c.beginPath();a.forEach((v,i)=>{const x=i*w/(a.length-1),y=h-18-(v-lo)/r*(h-40);i?c.lineTo(x,y):c.moveTo(x,y)});c.strokeStyle='#79c36a';c.lineWidth=2;c.stroke()}
function select(r){if(!r)return;selected=r;root.querySelector('#gm-selected').textContent=r.dataset.name;root.querySelector('#gm-price').textContent='₹'+Number(r.dataset.price).toFixed(2)+' / '+r.dataset.unit;const ch=Number(r.dataset.change),el=root.querySelector('#gm-change');el.textContent=(ch>=0?'+':'')+ch.toFixed(2)+'% today';el.style.color=ch>=0?'#60d477':'#ef7b7b';draw()}
function book(){if(!selected)return;root.querySelector('#gm-form-name').textContent=selected.dataset.name;root.querySelector('#gm-form-quote').textContent='₹'+Number(selected.dataset.price).toFixed(2)+' / '+selected.dataset.unit;root.querySelector('#gm-form-market').value=selected.dataset.name;root.querySelector('#gm-form-price').value=selected.dataset.price;root.querySelector('#gm-form-symbol').value=selected.dataset.symbol;dialog.showModal()}
rows.forEach(r=>r.querySelector('[data-select-market]').addEventListener('click',()=>select(r)));root.querySelectorAll('[data-book-price]').forEach(b=>b.addEventListener('click',book));root.querySelector('[data-close]').addEventListener('click',()=>dialog.close());root.querySelector('#gm-search').addEventListener('input',e=>rows.forEach(r=>r.style.display=r.dataset.name.toLowerCase().includes(e.target.value.toLowerCase())?'':'none'));window.addEventListener('resize',draw);select(selected)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
